// modal-contact ile phone-verification olaylarla haberleşir
import { applyValidations, clearValidations } from "./form-validations";
document.addEventListener("DOMContentLoaded", () => {
  const /** @type HTMLDivElement */ modal_contact =
      document.getElementById("modal-contact");
  const /** @type HTMLFormElement */ phone_verification_form =
      modal_contact.querySelector("#phone_verification_form");
  if (!modal_contact || !phone_verification_form) {
    return;
  }
  phone_verification_form.addEventListener("submit", async (e) => {
    e.preventDefault();
    const /** @type HTMLButtonElement */ submitButton =
        contact_form.querySelector('button[type="submit"][data-loading-text]');
    const f = new FormData(phone_verification_form);
    if (submitButton) {
      submitButton.setAttribute("data-original-text", submitButton.innerText);
      submitButton.innerText = submitButton.dataset.loadingText;
      submitButton.disabled = true;
    }
    const data = await fetch(phone_verification_form.action, {
      method: "POST",
      body: f,
    }).then((response) => response.json());
    if (submitButton) {
      submitButton.innerText = submitButton.getAttribute("data-original-text");
      submitButton.disabled = false;
    }
    if (data.validations) {
      applyValidations(phone_verification_form, data.validations);
      return;
    } else {
      clearValidations(phone_verification_form);
    }

    if (data.message) {
      alert(data.message);
      return;
    }
    if (data.status) {
      modal_contact.dispatchEvent(new CustomEvent("contact-ok"));
    }
  });
});
